import Layout from "./Layout";

const Index = () => {
  return (
    <div>
      <Layout />
    </div>
  );
};

export default Index;
